import {
  APIBlobResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";
import {
  GetStorageCostDetailParams,
  GetStorageCostParams,
  RecalculateStorageCostParams,
  StorageCostDetailItem,
  StorageCostListItem,
} from "../models/StorageCost/StorageCost";
import { downloadCSV, getAPI, postAPI } from "./Networking";
import { APIResponse } from "../models/NetworkResponse";
export default class StorageCostAPI {
  getStorageCostListing = async (
    params: GetStorageCostParams,
  ): Promise<PaginatedAPIResponse<StorageCostListItem>> => {
    try {
      const queryParams = new URLSearchParams();
      if (params.sort_by) queryParams.append("sort_by", params.sort_by);
      if (params.sort_type) queryParams.append("sort_type", params.sort_type);
      if (params.search_text)
        queryParams.append("search_text", params.search_text);
      if (params.customer_name)
        queryParams.append("customer_name", params.customer_name);
      if (params.partner_tag)
        queryParams.append("partner_tag", params.partner_tag);
      if (params.cost_date_from)
        queryParams.append("cost_date_from", params.cost_date_from);
      if (params.cost_date_to)
        queryParams.append("cost_date_to", params.cost_date_to);

      const response = await getAPI(
        `/v1/storagecost?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getStorageCostDetail = async (
    params: GetStorageCostDetailParams,
  ): Promise<PaginatedAPIResponse<StorageCostDetailItem>> => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("cost_date_from", params.cost_date_from);
      queryParams.append("cost_date_to", params.cost_date_to);
      queryParams.append("sort_by", params.sort_by || "id");
      queryParams.append("sort_type", params.sort_type || "DESC");
      if (params.search_text)
        queryParams.append("search_text", params.search_text);
      if (params.selected_packs_sku)
        queryParams.append("selected_packs_sku", params.selected_packs_sku);
      if (params.partner_tag)
        queryParams.append("partner_tag", params.partner_tag);
      if (params.size) queryParams.append("size", params.size);
      const response = await getAPI(
        `/v1/storagecost/${params.id}?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  recalculateStorageCost = async (
    params: RecalculateStorageCostParams,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v1/inventory-storage-calc/recalculate`, {
        inventory_id: params.inventory_id,
        start_date: params.cost_date_from,
        end_date: params.cost_date_to,
      });
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  downloadStorageCostDetailReport = async (
    params: GetStorageCostDetailParams,
  ): Promise<APIBlobResponse> => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("cost_date_from", params.cost_date_from);
      queryParams.append("cost_date_to", params.cost_date_to);
      queryParams.append("sort_by", params.sort_by || "date");
      queryParams.append("sort_type", params.sort_type || "DESC");
      if (params.search_text)
        queryParams.append("search_text", params.search_text);
      if (params.selected_packs_sku)
        queryParams.append("selected_packs_sku", params.selected_packs_sku);
      if (params.partner_tag)
        queryParams.append("partner_tag", params.partner_tag);
      if (params.size) queryParams.append("size", params.size);
      queryParams.append("download_report", true.toString());
      const response = await downloadCSV(
        `/v1/storagecost/download-detail-report/${params.id}?${queryParams.toString()}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  searchTags = async (search_text: string): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v1/storagecost/search-tags?search_text=${search_text}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
